<template>
  <div class="mobile">
    <div class="share" @click="showPopup = true"></div>
    <div class="header"></div>
    <div class="main">
      <div
        class="linkBox"
        v-for="item in urlList"
        :key="item.name"
        @click="jumpUrl(item.url)"
      >
        <div class="linkIcon"></div>
        <div class="linkTitle">{{ decodeURIComponent(item.name) }}</div>
      </div>
    </div>
    <div class="logo"></div>
    <div class="sizeBox"></div>
    <van-popup v-model="showPopup" position="bottom">
      <div class="menuBox">
        <div class="menu" @click="showImgPopup = true">生成分享卡</div>
        <div class="menu" @click="doCopy">复制链接</div>
        <div class="menu" @click="showPopup = false">取消</div>
        <div class="barBox">
          <div class="bar"></div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showImgPopup">
      <div class="sharePopup">
        <div class="titleBox" @click="saveImage">
          <div class="click"></div>
          <span>点击图片保存</span>
        </div>
        <div class="shareMain" ref="saveImage">
          <div class="shareHeader"></div>
          <div class="shareLinkBox" v-for="item in urlList" :key="item.name">
            <div class="shareLinkIcon"></div>
            <div class="shareLinkTitle">
              {{ decodeURIComponent(item.name) }}
            </div>
          </div>
          <div class="mask">
            <div class="logoText"></div>
            <div class="qrcodeBox">
              <img class="qrcode" :src="qrImg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mixins } from "./../../../mixin/index";
export default {
  name: "mobile",
  mixins: [mixins],
};
</script>
<style lang="scss" scoped>
.mobile {
  height: 100%;
  overflow-y: auto;
  background: black;
  padding: 75px 29px 0px;
  position: relative;
  .share {
    height: 45px;
    width: 75px;
    background: url("./../../../assets/png/share.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 30px;
    top: 25px;
    z-index: 1;
  }
  .header {
    height: 254px;
    width: 316px;
    background: url("./../../../assets/png/header.webp") no-repeat;
    background-size: 100% 100%;
  }
  .main {
    margin-top: 40px;
    .linkBox {
      height: 52px;
      background: white;
      border-radius: 10px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      padding: 0 16px;
      .linkIcon {
        height: 30px;
        width: 30px;
        background: url("./../../../assets/png/linkIcon.png") no-repeat;
        background-size: 100% 100%;
      }
      .linkTitle {
        color: #000;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        flex: 1;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
  }
  .logo {
    height: 30px;
    width: 316px;
    background: url("./../../../assets/png/logo.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 45px;
  }
  .sizeBox {
    height: 150px;
  }
  // 弹窗
  .menuBox {
    background: white;
    .menu {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding: 14px 0;
      border-bottom: 0.5px solid #dadada;
    }
    .barBox {
      height: 21px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .bar {
        height: 5px;
        width: 135px;
        border-radius: 5px;
        background: #0d0d0d;
      }
    }
  }
  .sharePopup {
    height: 100vh;
    overflow-y: auto;
    .titleBox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0 12px;
      .click {
        height: 18px;
        width: 18px;
        background: url("./../../../assets/png/click.png") no-repeat;
        background-size: 100% 100%;
      }
      span {
        color: #fff;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 12.533px; /* 104.444% */
        letter-spacing: 0.24px;
      }
    }
    .shareMain {
      width: 235px;
      height: 756px;
      padding: 20px 18px;
      background: #000;
      border-radius: 4px;
      overflow: hidden;
      margin-bottom: 16px;
      position: relative;
      .shareHeader {
        height: 129px;
        width: 198px;
        background: url("./../../../assets/png/header.webp") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto 35px;
      }
      .shareLinkBox {
        height: 32.5px;
        background: white;
        border-radius: 4px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        padding: 0 10.56px;
        .shareLinkIcon {
          height: 18.8px;
          width: 18.8px;
          background: url("./../../../assets/png/linkIcon.png") no-repeat;
          background-size: 100% 100%;
        }
        .shareLinkTitle {
          color: #000;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 10px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          flex: 1;
          position: absolute;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
      .mask {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 178px;
        width: 100%;
        border-radius: 0px 0px 5px 5px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 43.88%);
        .logoText {
          height: 28px;
          width: 110px;
          background: url("./../../../assets/png/logoText.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          left: 19px;
          bottom: 26px;
        }
        .qrcodeBox {
          position: absolute;
          right: 19px;
          bottom: 18px;
          background: white;
          height: 44px;
          width: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          overflow: hidden;
          .qrcode {
            height: 38px;
            width: 38px;
            background-color: white;
            margin: 0 1px 1px 0px;
          }
        }
      }
    }
  }
}
.van-popup {
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  background: transparent;
}
</style>
